import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import SchemeDashboard from '../../../PerksHub/SchemeDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { CHART_COLORS } from '../../../../component/common/designSystem';
import { fetchHealthScheme } from './companyPerksApi';

/**
 * Company Perks → Health Scheme. Same dashboard as Salary Sacrifice — the two
 * programmes share a data shape — with its own accent and the cash-plan /
 * occupational-plan split the payload adds.
 */
const CPerksHealthScheme = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchHealthScheme(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Health Scheme | Shoorah</title>
      </Helmet>
      <SchemeDashboard
        fetcher={fetcher}
        title="Health Scheme"
        noun="scheme"
        accent={CHART_COLORS.teal}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CPerksHealthScheme;
